<template>
  <div :class="$style.wrapper">
    <header :class="$style.header">
      <div>
        <p :class="$style.headerLabel">Документация</p>
        <h1>Политика конфиденциальности</h1>
      </div>
    </header>

    <article :class="$style.article">
      <section :class="$style.section">
        <h2>1. Общие положения</h2>
        <p>
          Настоящая политика обработки персональных данных составлена в
          соответствии с требованиями Федерального закона от 27.07.2006. №
          152-ФЗ «О персональных данных» (далее — Закон о персональных данных) и
          определяет порядок обработки персональных данных и меры по обеспечению
          безопасности персональных данных, предпринимаемые ИП Сукачом Олегом
          Ювенальевичем (далее — Оператор).
        </p>
        <p>
          1.1. Оператор ставит своей важнейшей целью и условием осуществления
          своей деятельности соблюдение прав и свобод человека и гражданина при
          обработке его персональных данных, в том числе защиты прав на
          неприкосновенность частной жизни, личную и семейную тайну.
        </p>
        <p>
          1.2. Настоящая политика Оператора в отношении обработки персональных
          данных (далее — Политика) применяется ко всей информации, которую
          Оператор может получить о посетителях веб-сайта
          https://snkrroom-resell.ru.
        </p>
      </section>

      <section :class="$style.section">
        <h2>2. Основные понятия, используемые в Политике</h2>
        <ul>
          <li>
            2.1. Автоматизированная обработка персональных данных — обработка
            персональных данных с помощью средств вычислительной техники.
          </li>
          <li>
            2.2. Блокирование персональных данных — временное прекращение
            обработки персональных данных (за исключением случаев, если
            обработка необходима для уточнения персональных данных).
          </li>
          <li>
            2.3. Веб-сайт — совокупность графических и информационных
            материалов, а также программ для ЭВМ и баз данных, обеспечивающих их
            доступность в сети интернет по сетевому адресу
            https://snkrroom-resell.ru.
          </li>
          <li>
            2.4. Информационная система персональных данных — совокупность
            содержащихся в базах данных персональных данных и обеспечивающих их
            обработку информационных технологий и технических средств.
          </li>
          <li>
            2.5. Обезличивание персональных данных — действия, в результате
            которых невозможно определить без использования дополнительной
            информации принадлежность персональных данных конкретному
            Пользователю или иному субъекту персональных данных.
          </li>
          <li>
            2.6. Обработка персональных данных — любое действие (операция) или
            совокупность действий (операций), совершаемых с использованием
            средств автоматизации или без использования таких средств с
            персональными данными.
          </li>
          <li>
            2.7. Оператор — государственный орган, муниципальный орган,
            юридическое или физическое лицо, самостоятельно или совместно с
            другими лицами организующие и/или осуществляющие обработку
            персональных данных.
          </li>
          <li>
            2.8. Персональные данные — любая информация, относящаяся прямо или
            косвенно к определенному или определяемому Пользователю веб-сайта
            https://snkrroom-resell.ru.
          </li>
          <li>
            2.9. Персональные данные, разрешенные субъектом персональных данных
            для распространения, — персональные данные, доступ неограниченного
            круга лиц к которым предоставлен субъектом персональных данных путем
            дачи согласия.
          </li>
          <li>
            2.10. Пользователь — любой посетитель веб-сайта
            https://snkrroom-resell.ru.
          </li>
          <li>
            2.11. Предоставление персональных данных — действия, направленные на
            раскрытие персональных данных определенному лицу или определенному
            кругу лиц.
          </li>
          <li>
            2.12. Распространение персональных данных — любые действия,
            направленные на раскрытие персональных данных неопределенному кругу
            лиц или на ознакомление с персональными данными неограниченного
            круга лиц.
          </li>
          <li>
            2.13. Трансграничная передача персональных данных — передача
            персональных данных на территорию иностранного государства органу
            власти иностранного государства, иностранному физическому или
            иностранному юридическому лицу.
          </li>
          <li>
            2.14. Уничтожение персональных данных — любые действия, в результате
            которых персональные данные уничтожаются безвозвратно с
            невозможностью дальнейшего восстановления.
          </li>
        </ul>
      </section>

      <section :class="$style.section">
        <h2>3. Основные права и обязанности Оператора</h2>
        <p>3.1. Оператор имеет право:</p>
        <ul>
          <li>
            получать от субъекта персональных данных достоверную информацию
            и/или документы, содержащие персональные данные;
          </li>
          <li>
            в случае отзыва согласия продолжить обработку персональных данных
            при наличии оснований, указанных в Законе о персональных данных;
          </li>
          <li>
            самостоятельно определять состав и перечень мер, необходимых и
            достаточных для обеспечения выполнения обязанностей, предусмотренных
            Законом о персональных данных.
          </li>
        </ul>
        <p>3.2. Оператор обязан:</p>
        <ul>
          <li>
            предоставлять субъекту персональных данных по его просьбе
            информацию, касающуюся обработки его персональных данных;
          </li>
          <li>
            организовывать обработку персональных данных в порядке,
            установленном действующим законодательством РФ;
          </li>
          <li>
            отвечать на обращения и запросы субъектов персональных данных и их
            законных представителей;
          </li>
          <li>
            принимать правовые, организационные и технические меры для защиты
            персональных данных от неправомерного или случайного доступа,
            уничтожения, изменения, блокирования, копирования, предоставления,
            распространения, а также от иных неправомерных действий;
          </li>
          <li>
            прекращать передачу и обработку персональных данных и уничтожать их
            в случаях, предусмотренных законодательством;
          </li>
          <li>исполнять иные обязанности, предусмотренные Законом.</li>
        </ul>
      </section>

      <section :class="$style.section">
        <h2>4. Основные права и обязанности субъектов персональных данных</h2>
        <p>4.1. Субъекты персональных данных имеют право:</p>
        <ul>
          <li>
            получать информацию, касающуюся обработки его персональных данных;
          </li>
          <li>
            требовать уточнения, блокирования или уничтожения персональных
            данных, если они являются неполными, устаревшими, неточными или
            незаконно полученными;
          </li>
          <li>
            выдвигать условие предварительного согласия при обработке
            персональных данных в целях продвижения товаров, работ и услуг;
          </li>
          <li>
            отзывать согласие на обработку персональных данных и требовать
            прекращения обработки;
          </li>
          <li>
            обжаловать неправомерные действия или бездействие Оператора в
            уполномоченный орган или суд;
          </li>
        </ul>
        <p>4.2. Субъекты персональных данных обязаны:</p>
        <ul>
          <li>предоставлять Оператору достоверные данные о себе;</li>
          <li>
            сообщать об уточнении (обновлении, изменении) своих персональных
            данных.
          </li>
        </ul>
      </section>

      <section :class="$style.section">
        <h2>5. Принципы обработки персональных данных</h2>
        <ul>
          <li>
            5.1. Обработка персональных данных осуществляется на законной и
            справедливой основе.
          </li>
          <li>
            5.2. Обработка персональных данных ограничивается достижением
            конкретных, заранее определенных и законных целей.
          </li>
          <li>
            5.3. Не допускается объединение баз данных, содержащих персональные
            данные, обработка которых осуществляется в целях, несовместимых
            между собой.
          </li>
          <li>
            5.4. Обработке подлежат только персональные данные, которые отвечают
            целям их обработки.
          </li>
          <li>
            5.5. Содержание и объём обрабатываемых персональных данных
            соответствуют заявленным целям обработки.
          </li>
          <li>
            5.6. Обеспечивается точность, достаточность и актуальность
            персональных данных.
          </li>
          <li>
            5.7. Хранение персональных данных осуществляется не дольше, чем
            этого требуют цели обработки.
          </li>
        </ul>
      </section>

      <section :class="$style.section">
        <h2>6. Цели обработки персональных данных</h2>
        <p>
          Цель обработки — предоставление доступа Пользователю к сервисам,
          информации и/или материалам, содержащимся на веб-сайте.
        </p>
        <p>
          Персональные данные: электронный адрес, номера телефонов, Telegram ID.
        </p>
        <p>Правовые основания: уставные (учредительные) документы Оператора.</p>
        <p>
          Виды обработки: сбор, запись, систематизация, накопление, хранение,
          уничтожение и обезличивание персональных данных, отправка
          информационных писем.
        </p>
      </section>

      <section :class="$style.section">
        <h2>7. Условия обработки персональных данных</h2>
        <ul>
          <li>
            7.1. Обработка осуществляется с согласия субъекта персональных
            данных.
          </li>
          <li>
            7.2. Обработка необходима для исполнения обязанностей оператора.
          </li>
          <li>
            7.3. Обработка необходима для осуществления правосудия и исполнения
            судебных актов.
          </li>
          <li>
            7.4. Обработка необходима для исполнения или заключения договора с
            субъектом.
          </li>
          <li>
            7.5. Обработка необходима для осуществления прав и законных
            интересов оператора или третьих лиц.
          </li>
          <li>7.6. Обработка общедоступных персональных данных.</li>
          <li>
            7.7. Обработка данных, подлежащих обязательному раскрытию по закону.
          </li>
        </ul>
      </section>

      <section :class="$style.section">
        <h2>8. Порядок сбора, хранения, передачи и других видов обработки</h2>
        <p>
          Безопасность персональных данных обеспечивается правовыми,
          организационными и техническими мерами в соответствии с действующим
          законодательством.
        </p>
        <ul>
          <li>
            8.1. Оператор обеспечивает сохранность персональных данных и
            исключает доступ к ним неуполномоченных лиц.
          </li>
          <li>
            8.2. Персональные данные Пользователя не передаются третьим лицам,
            кроме случаев, предусмотренных законом или с согласия Пользователя.
          </li>
          <li>
            8.3. Пользователь может актуализировать данные, направив запрос на
            info@snkrroom.ru с пометкой «Актуализация персональных данных».
          </li>
          <li>
            8.4. Пользователь может отозвать согласие на обработку персональных
            данных, направив уведомление на info@snkrroom.ru с пометкой «Отзыв
            согласия на обработку персональных данных».
          </li>
          <li>
            8.5. Информация, собираемая сторонними сервисами (платёжные системы,
            операторы связи и др.), хранится и обрабатывается ими по их
            собственным правилам.
          </li>
          <li>
            8.6. Запреты субъекта на распространение данных не действуют в
            случаях обработки в государственных, общественных и иных публичных
            интересах.
          </li>
          <li>
            8.7. Оператор обеспечивает конфиденциальность персональных данных.
          </li>
          <li>
            8.8. Хранение персональных данных осуществляется не дольше, чем
            этого требуют цели обработки.
          </li>
          <li>
            8.9. Основанием прекращения обработки могут быть достижение целей,
            отзыв согласия, требование субъекта или выявление неправомерной
            обработки.
          </li>
        </ul>
      </section>

      <section :class="$style.section">
        <h2>9. Перечень действий с персональными данными</h2>
        <ul>
          <li>
            9.1. Оператор осуществляет сбор, запись, систематизацию, накопление,
            хранение, уточнение, извлечение, использование, передачу,
            обезличивание, блокирование, удаление и уничтожение персональных
            данных.
          </li>
          <li>
            9.2. Осуществляется автоматизированная обработка персональных
            данных, в том числе с передачей по
            информационно-телекоммуникационным сетям.
          </li>
        </ul>
      </section>

      <section :class="$style.section">
        <h2>10. Трансграничная передача персональных данных</h2>
        <ul>
          <li>
            10.1. До начала трансграничной передачи Оператор уведомляет
            уполномоченный орган по защите прав субъектов персональных данных о
            своём намерении.
          </li>
          <li>
            10.2. До подачи уведомления Оператор получает необходимые сведения
            от иностранных получателей персональных данных.
          </li>
        </ul>
      </section>

      <section :class="$style.section">
        <h2>11. Конфиденциальность персональных данных</h2>
        <p>
          Оператор и иные лица, получившие доступ к персональным данным, обязаны
          не раскрывать и не распространять персональные данные без согласия
          субъекта, если иное не предусмотрено федеральным законом.
        </p>
      </section>

      <section :class="$style.section">
        <h2>12. Заключительные положения</h2>
        <p>
          12.1. Пользователь может получить разъяснения по вопросам, касающимся
          обработки его персональных данных, обратившись по адресу
          info@snkrroom.ru.
        </p>
        <p>
          12.2. В настоящем документе будут отражены любые изменения политики
          обработки персональных данных Оператором. Политика действует бессрочно
          до замены её новой версией.
        </p>
        <p>
          12.3. Актуальная версия Политики доступна по адресу
          https://snkrroom-resell.ru/docs/privacy-policy.
        </p>
      </section>
    </article>
  </div>
</template>

<script>
export default {
  name: "DocsPrivacy",
}
</script>

<style lang="scss" module>
.wrapper {
  padding: 1.25rem 1rem 6rem 1rem;
}

.header {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  margin-bottom: 1rem;
}

.headerLabel {
  font-size: 0.75rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #9b9ba1;
  margin: 0 0 0.15rem 0;
}

.header h1 {
  font-size: 1.3rem;
  line-height: 1.25;
  margin: 0;
}

.article {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.section {
  border: 1px solid #ebeaea;
  border-radius: 0.75rem;
  padding: 1rem;
  background: #fff;
}

.section h2 {
  margin: 0 0 0.5rem 0;
  font-size: 1.05rem;
}

.section p {
  margin: 0 0 0.5rem 0;
  line-height: 1.45;
  color: #2c2d30;
}

.section ul {
  margin: 0;
  padding-left: 1.1rem;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  color: #2c2d30;
  line-height: 1.4;
}
</style>
